import { DateInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import PessoaJuridicaAutocomplete from './PessoaJuridicaAutocomplete';

const PessoaJuridica = (props) => {
  const { handleChange, handleBlur, touched, errors, readOnly, disabled, papel, fetchPapel } = props;
  const { pessoa } = props;
  const { pessoaJuridica = {}, inscricaoMunicipal } = pessoa || {};
  const { razaoSocial, dataFundacao = null, indicadorInscricaoEstadual, inscricaoEstadual } = pessoaJuridica;

  return (
    <>
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <PessoaJuridicaAutocomplete
          required
          value={pessoa}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched?.pessoa?.pessoaJuridica?.cnpj}
          error={errors?.pessoa?.pessoaJuridica?.cnpj}
          disabled={disabled}
          papel={papel}
          fetchPapel={fetchPapel}
        />
      </Grid>
      <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaJuridica.razaoSocial"
          label="Razão social"
          onChange={handleChange}
          value={razaoSocial}
          maxLength={150}
          error={errors?.pessoa?.pessoaJuridica?.razaoSocial}
          touched={touched?.pessoa?.pessoaJuridica?.razaoSocial}
        />
      </Grid>
      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
        <DateInput
          readOnly={readOnly}
          id="pessoa.pessoaJuridica.dataFundacao"
          label="Data de fundação"
          cancelLabel
          onChange={handleChange}
          value={dataFundacao}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <SelectInput
          readOnly={readOnly}
          label="Indicador de inscrição estadual"
          id="pessoa.pessoaJuridica.indicadorInscricaoEstadual"
          onChange={handleChange}
          onBlur={handleBlur}
          value={indicadorInscricaoEstadual}
          options={[
            { id: 'CONTRIBUINTE', title: 'Contribuinte de ICMS' },
            { id: 'NAO_CONTRIBUINTE', title: 'Não contribuinte de ICMS ' },
            { id: 'CONTRIBUINTE_ISENTO', title: 'Contribuinte isento' },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.pessoaJuridica.inscricaoEstadual"
          label="Inscrição estadual"
          replace={{ searchValue: /[^0-9]/gm, newValue: '' }}
          pattern={/^[0-9]*$/gm}
          onChange={handleChange}
          value={inscricaoEstadual}
          maxLength={20}
          error={errors?.pessoa?.pessoaJuridica?.inscricaoEstadual}
          touched={touched?.pessoa?.pessoaJuridica?.inscricaoEstadual}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <TextInput
          readOnly={readOnly}
          fullWidth
          id="pessoa.inscricaoMunicipal"
          label="Inscrição municipal"
          onChange={handleChange}
          value={inscricaoMunicipal}
          maxLength={20}
          error={errors?.pessoa?.inscricaoMunicipal}
          touched={touched?.pessoa?.inscricaoMunicipal}
        />
      </Grid>
    </>
  );
};

PessoaJuridica.defaultProps = {
  pessoa: {
    pessoaJuridica: PropTypes.shape({
      dataFundacao: null,
    }),
  },
};

PessoaJuridica.propTypes = {
  pessoa: PropTypes.shape({
    pessoaJuridica: PropTypes.shape({
      cnpj: PropTypes.string,
      razaoSocial: PropTypes.string,
      indicadorInscricaoEstadual: PropTypes.string,
      inscricaoEstadual: PropTypes.string,
      inscricaoMunicipal: PropTypes.string,
    }),
  }),
};

export default PessoaJuridica;
